import React, { Fragment, useEffect, useState } from 'react'
import useAxios from 'axios-hooks'
import { getAuthHeader } from 'utils/auth'
import { StringParam, useQueryParams } from 'use-query-params'
import { useProjects } from 'context/project-context'
import ScanWidgets from 'views/ScanSettings/Scan/components/ScanWidgets'
import ScanTop from 'views/ScanSettings/Scan/components/ScanTop'
import ScanView from 'views/ScanSettings/components/ScanView'
import { ErrorBoundary } from 'components'
import {usePayment} from 'context/payment-context';

export const UNAVAILABLE_FOR_TRIAL = "Unavailable for trial"

const blockEntitiesInTrial = (trialConfiguration, scanViewData, isDetailsView) => {
  if(trialConfiguration && (scanViewData.documents || scanViewData.entities)){
    
    let data = scanViewData.documents || scanViewData.entities;
    const maxAmount = isDetailsView ? trialConfiguration.errors_to_show : trialConfiguration.documents_to_show;
    data.forEach((item, index) => {
      if(index + 1 > maxAmount && !isDetailsView){
        item.notAllowed = true;
      }
    })

    if(isDetailsView){
      const available = data.filter(d => d.selector !== UNAVAILABLE_FOR_TRIAL);
      const Unavailable = data.filter(d => d.selector === UNAVAILABLE_FOR_TRIAL);
      scanViewData.entities = [...available, ...Unavailable];
    }
  }
}

function Scan({ scanSettingsId, scanId }) {
  const { project } = useProjects()
  const {trialConfiguration} = usePayment();
  const [detailsView, setDetailsView] = useQueryParams({
    details: StringParam
  })
  const [exportFilters, setFiltersForExport] = useState([])
  const [exportError, setExportError] = useState(null)

  const [{ data: scanData, loading: loadingScanData, error: scanDataError }, fetchScanData] = useAxios(
    {
      method: 'POST',
      url: `/${project.name}/scan-settings/scans/${scanId}`,
      headers: getAuthHeader()
    },
    { manual: true }
  )

  const [{ data: detailsData, loading: loadingDetailsData, error: detailsError }, fetchScanDetails] = useAxios(
    {
      method: 'POST',
      url: `/${project.name}/scan-settings/scans/${scanId}/document/${detailsView.details}`,
      headers: getAuthHeader()
    },
    { manual: true }
  )

  let isDetailsView = !!detailsView.details
  let scanViewData = scanData || {}
  let loadingData = loadingScanData || loadingDetailsData
  let fetchError = scanDataError || detailsError || exportError
  if (isDetailsView && detailsData) {
    scanViewData = detailsData
  }

  blockEntitiesInTrial(trialConfiguration, scanViewData, isDetailsView);

  const scanStatus = isDetailsView ? scanViewData?.stats?.status : scanViewData?.stats?.state;
  const availableStatus = ["complete", "stopped"];
  let exportEnabled = scanStatus && availableStatus.includes(scanStatus.toLowerCase());
  let scanSettingsName = scanViewData && scanViewData['scan_settings_name']

  return (
    <ErrorBoundary>
      <ScanTop
        documentId={detailsView.details}
        scanName={scanSettingsName}
        scanSettingsId={scanSettingsId}
        scanId={scanId}
        scanStatus={scanStatus}
        isDetailsView={isDetailsView}
        setDetailsView={setDetailsView}
				exportFilters={exportFilters}
        onExportError={setExportError}
        exportEnabled={exportEnabled}
      />
      <ScanView
        scanViewData={scanViewData}
        scanStatus={scanStatus && scanStatus.toLowerCase()}
        fetchData={fetchScanData}
        fetchDetails={fetchScanDetails}
        fetchError={fetchError}
        loadingData={loadingData}
        withPolling={true}
        widgets={ScanWidgets}
        isDetailsView={isDetailsView}
        setDetailsView={setDetailsView}
        scanName={scanSettingsName}
				onFiltersChange={setFiltersForExport}
      />
    </ErrorBoundary>
  )
}

export default Scan
